var _require = require('../utils'),
    isContainer = _require.isContainer,
    map = _require.map,
    CountedOrderedSet = _require.CountedOrderedSet;

function flatten(data, set) {
  var recurse = function recurse(data) {
    return flatten(data, set);
  };

  var flattened = isContainer(data) ? map(data, recurse) : data;
  return set.add(flattened);
}

module.exports = function crunch(data) {
  var set = CountedOrderedSet();
  flatten(data, set);
  return set.values;
};